export default __webpack_public_path__ + "static/media/orgs_level.c623cc14.svg";